'use client';

import jsCookie from 'js-cookie';

export const REFERRAL_COOKIE_NAME = 'gd_ref_id';
export const FIRSTPROMOTER_REFERRAL_COOKIE_NAME = '_fprom_ref';

export function getReferralIdFromQuery() {
  try {
    if (typeof window !== 'undefined') {
      const urlSearchParams = new URLSearchParams(window.location.search);
      return urlSearchParams.get('via') ?? '';
    }
  } catch (e) {}

  return '';
}

export function getReferralIdFromCookie() {
  return jsCookie.get(REFERRAL_COOKIE_NAME) ?? '';
}

export function getReferralIdFromFirstPromoterCookie() {
  return jsCookie.get(FIRSTPROMOTER_REFERRAL_COOKIE_NAME) ?? '';
}

export function getReferralId() {
  let refId = getReferralIdFromQuery();

  if (!refId) {
    refId = getReferralIdFromFirstPromoterCookie();
  }

  if (!refId) {
    refId = getReferralIdFromCookie();
  }

  return refId;
}
